/**
 * Cluster-specific error classes.
 *
 * Subclasses ToolErrors.InvalidInputError so the existing window.ToolErrors.handle()
 * routes them through the standard toast/critical-event pipeline by duck-typing
 * on err.name. No edit to public/js/tool-errors.js required.
 */
(function (w) {
    'use strict';
    w.__DiskImage = w.__DiskImage || {};
    if (w.__DiskImage.errors) return;

    var Base = (w.ToolErrors && w.ToolErrors.InvalidInputError) || Error;

    function _ext(name, defaultReason) {
        function E(msg, details) {
            var e = new Base(msg || name, details || {});
            e.name = name;
            e.reason = (details && details.reason) || defaultReason;
            if (details) {
                Object.keys(details).forEach(function (k) {
                    if (k !== 'reason') e[k] = details[k];
                });
            }
            return e;
        }
        E.is = function (err) { return err && err.name === name; };
        return E;
    }

    var UnsupportedFilesystemError = _ext('UnsupportedFilesystemError', 'wrong_file_type');
    var CorruptedImageError = _ext('CorruptedImageError', 'invalid_input');
    var MemoryGuardError = _ext('MemoryGuardError', 'too_large');
    var BootCatalogMissingError = _ext('BootCatalogMissingError', 'invalid_input');
    var TruncatedImageError = _ext('TruncatedImageError', 'invalid_input');

    w.__DiskImage.errors = {
        UnsupportedFilesystemError: UnsupportedFilesystemError,
        CorruptedImageError: CorruptedImageError,
        MemoryGuardError: MemoryGuardError,
        BootCatalogMissingError: BootCatalogMissingError,
        TruncatedImageError: TruncatedImageError
    };
    w.DiskImageErrors = w.__DiskImage.errors; // public alias
})(window);
